
import * as storyblokRuntime$NDxBV0XHqc from '/app/node_modules/.pnpm/@nuxt+image@1.9.0_db0@0.2.1_ioredis@5.4.2_magicast@0.3.5_rollup@4.30.1/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$FvWV00z22W from '/app/node_modules/.pnpm/@nuxt+image@1.9.0_db0@0.2.1_ioredis@5.4.2_magicast@0.3.5_rollup@4.30.1/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "phone": 0,
    "tablet": 640,
    "desktop": 1024,
    "ext": 1200
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "a.storyblok.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "png",
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$NDxBV0XHqc, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$FvWV00z22W, defaults: {} }
}
        